import { TextField } from "@mui/material";
import { StandaloneSearchBox } from "@react-google-maps/api";
import React from "react";
export const SearchBox = ({ disabled = false, onPlaceChange, placeholder, }) => {
    const ref = React.createRef();
    const onPlacesChanged = () => {
        const places = ref.current?.state.searchBox?.getPlaces();
        if (Array.isArray(places) && places.length > 0) {
            onPlaceChange(places[0]);
        }
        else {
            onPlaceChange({});
        }
    };
    return (React.createElement(StandaloneSearchBox, { ref: ref, onPlacesChanged: onPlacesChanged },
        React.createElement(TextField, { disabled: disabled, fullWidth: true, placeholder: placeholder, type: "text" })));
};
//# sourceMappingURL=search-box.js.map